import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { SubscriptionUnderwritingDocumentPageSkeleton } from '#/modules/ai-underwriting/back-office/subscription-underwriting-document-page/subscription-underwriting-document-page-skeleton.tsx'
import { SubscriptionUnderwritingDocumentPage } from '#/modules/ai-underwriting/back-office/subscription-underwriting-document-page/subscription-underwriting-document-page.tsx'
import { SUBSCRIPTION_UNDERWRITING_QUERY_OPTIONS } from '#/modules/ai/queries/subscription-underwriting-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

/** `fieldKey`: the field the page brings into sight. */
const searchSchema = type({ 'fieldKey?': 'string' })

export const Route = createFileRoute('/bo/subscriptions/$subscriptionId/documents/$documentKey')({
  beforeLoad: (options) =>
    requirePermissions(options, [anyOfPermissions('subscription.read', 'subscription.read.relatedOnly')]),
  validateSearch: searchSchema,
  // the one query the page suspends on, the same key its `useSuspenseQuery` reads
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      context.trpc.subscriptionApplication.getSubscriptionUnderwriting.queryOptions(
        { subscriptionId: params.subscriptionId },
        SUBSCRIPTION_UNDERWRITING_QUERY_OPTIONS,
      ),
    ),
  pendingComponent: SubscriptionUnderwritingDocumentPageSkeleton,
  pendingMs: 150,
  component: function Component() {
    const { subscriptionId, documentKey } = Route.useParams()
    const { fieldKey } = Route.useSearch()
    return (
      <SubscriptionUnderwritingDocumentPage
        key={documentKey}
        subscriptionId={subscriptionId}
        documentKey={documentKey}
        fieldKey={fieldKey}
      />
    )
  },
})
